module.exports = __webpack_public_path__ + "static/media/Пользовательское Соглашение.72a4b259.pdf";